// extracted by mini-css-extract-plugin
export default {"label":"Label_label__xoS5w","label__column":"Label_label__column__USwXO","label__text":"Label_label__text__spZwk","label__children":"Label_label__children__IhWTX"};